import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../api/client';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [navHeight, setNavHeight] = useState(84);
  const navbarRef = useRef(null);
  const location = useLocation();
  const [site, setSite] = useState({
    name: 'Revival Pharmacy',
    address: '1168 Albert Street, Regina, SK, S4R 2R1, Canada',
  });

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    api.publicSettings().then(setSite).catch(() => {});
  }, []);

  useEffect(() => {
    const updateNavHeight = () => {
      if (navbarRef.current) {
        setNavHeight(navbarRef.current.offsetHeight);
      }
    };

    updateNavHeight();

    const handleScroll = () => {
      if (window.scrollY > 45) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateNavHeight);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateNavHeight);
    };
  }, []);

  const path = location.pathname;
  const isHome = path === '/' || path === '/Home/Index';
  const isAbout = path === '/Home/About' || path === '/about';
  const isServices = path === '/Home/Contact' || path === '/services';
  const isGallery = path === '/Home/Gallery' || path === '/gallery';
  const isContact = path === '/Home/Info' || path === '/contact';
  const isLogin = path === '/Home/Login' || path === '/login';

  return (
    <header
      className={`site-header${isSticky ? ' has-sticky-navbar' : ''}`}
      id="header-one"
      style={{ paddingBottom: isSticky ? `${navHeight}px` : 0 }}
    >
      <div className="top-bar">
        <div className="container">
          <div className="row clearfix">
            <div className="col-lg-12">
              <div className="float-left">
                <a className="blink" style={{ color: "#568701", fontWeight: "bolder" }} href="https://maps.app.goo.gl/piQiW5AXBaCA6rQu8">{site.name}</a>
                <p><i className="fa fa-map-marker"></i> {site.address}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        ref={navbarRef}
        className={`navbar navbar-expand-lg${isSticky ? ' is-sticky' : ''}`}
      >
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src="/assets/image/logo.png" className="img-fluid" alt="Revival Pharmacy" />
          </a>
          <button
            className={`navbar-toggler toggler-spring${menuOpen ? ' is-open' : ''}`}
            type="button"
            aria-expanded={menuOpen}
            aria-controls="primary-navigation"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div id="primary-navigation" className={`collapse navbar-collapse${menuOpen ? ' show' : ''}`}>
            <ul className="navbar-nav navbar-mobile ml-auto mr-auto">
              <li className={`nav-item${isHome ? ' active' : ''}`}>
                <a className="nav-link link_hd" href="/" id="Header-Home" onClick={closeMenu}>Home</a>
              </li>

              <li className={`nav-item${isAbout ? ' active' : ''}`}>
                <a className="nav-link link_hd" href="/Home/About" id="Header-About" onClick={closeMenu}>Minor Ailments and Conditions</a>
              </li>

              <li className={`nav-item${isServices ? ' active' : ''}`}>
                <a className="nav-link link_hd" href="/Home/Contact" id="Header-Contect" onClick={closeMenu}>Services</a>
              </li>

              <li className={`nav-item${isGallery ? ' active' : ''}`}>
                <a className="nav-link link_hd" href="/Home/Gallery" id="Header-Gallery" onClick={closeMenu}>Gallery</a>
              </li>

              <li className={`nav-item${isContact ? ' active' : ''}`}>
                <a className="nav-link link_hd" href="/Home/Info" id="Header-Info" onClick={closeMenu}>Contact</a>
              </li>

              {/* <li className={`nav-item nav-item-login${isLogin ? ' active' : ''}`}>
                <a className="nav-link link_hd nav-login-btn" href="/admin/login" id="Header-Login" onClick={closeMenu}>
                  <i className="fa fa-sign-in" style={{ marginRight: '5px' }} />Login
                </a>
              </li>*/}
            </ul>
          </div>
        </div>
      </div>
      {/*End Main Header */}
    </header>
  );
}
